module.exports = __webpack_public_path__ + "img/team_1.126999ea.png";